(function () {
  var BALLISTYX_COLLECTIONS = {
    mens: {
      base: "/collections/mens-snowboards/Mens",
      sizes: {
        "136-142": "gid://shopify/FilterSettingGroup/82346047",
        "143-148": "gid://shopify/FilterSettingGroup/82378815",
        "149-152": "gid://shopify/FilterSettingGroup/82411583",
        "153-156": "gid://shopify/FilterSettingGroup/82444351",
        "157-161": "gid://shopify/FilterSettingGroup/82477119",
        "162-plus": "gid://shopify/FilterSettingGroup/82509887"
      },
      wideSizes: {
        "156w": "156w",
        "158w": "158w",
        "159w": "159w",
        "161w": "161w"
      }
    },
    womens: {
      base: "/collections/womens",
      sizes: {
        "136-142": "gid://shopify/FilterSettingGroup/82346047",
        "143-148": "gid://shopify/FilterSettingGroup/82378815",
        "149-152": "gid://shopify/FilterSettingGroup/82411583",
        "153-156": "gid://shopify/FilterSettingGroup/82444351",
        "157-161": "gid://shopify/FilterSettingGroup/82477119",
        "162-plus": "gid://shopify/FilterSettingGroup/82509887"
      }
    },
    unisex: {
      base: "/collections/mens-snowboards/Mens",
      sizes: {
        "136-142": "gid://shopify/FilterSettingGroup/82346047",
        "143-148": "gid://shopify/FilterSettingGroup/82378815",
        "149-152": "gid://shopify/FilterSettingGroup/82411583",
        "153-156": "gid://shopify/FilterSettingGroup/82444351",
        "157-161": "gid://shopify/FilterSettingGroup/82477119",
        "162-plus": "gid://shopify/FilterSettingGroup/82509887"
      },
      wideSizes: {
        "156w": "156w",
        "158w": "158w",
        "159w": "159w",
        "161w": "161w"
      }
    }
  };

  function $(id) {
    return document.getElementById(id);
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function normaliseUrl(url) {
    try {
      return new URL(url, window.location.origin).toString();
    } catch (e) {
      return url;
    }
  }

  function updateBootLabel() {
    var bootType = $("ballistyx-boot-type");
    var bootLabel = $("ballistyx-boot-label");

    if (!bootType || !bootLabel) return;

    if (bootType.value === "womens") {
      bootLabel.textContent = "Boot Size (US Women's)";
    } else {
      bootLabel.textContent = "Boot Size (US Men's)";
    }
  }

  function getBaseRangeFromWeight(weight, boardCategory) {
    if (boardCategory === "womens") {
      if (weight <= 45) return { min: 135, max: 139 };
      if (weight <= 50) return { min: 138, max: 142 };
      if (weight <= 55) return { min: 140, max: 144 };
      if (weight <= 65) return { min: 143, max: 148 };
      if (weight <= 75) return { min: 146, max: 152 };
      if (weight <= 85) return { min: 149, max: 154 };
      return { min: 152, max: 158 };
    }

    if (weight <= 50) return { min: 136, max: 141 };
    if (weight <= 55) return { min: 139, max: 145 };
    if (weight <= 60) return { min: 143, max: 149 };
    if (weight <= 65) return { min: 146, max: 152 };
    if (weight <= 75) return { min: 149, max: 155 };
    if (weight <= 85) return { min: 152, max: 159 };
    if (weight <= 90) return { min: 155, max: 162 };
    if (weight <= 100) return { min: 157, max: 166 };
    return { min: 160, max: 170 };
  }

  function adjustRangeForStyle(range, style) {
    var min = range.min;
    var max = range.max;

    if (style === "beginner") {
      max = Math.max(min, max - 2);
    } else if (style === "ground-tricks") {
      min = min - 3;
      max = max - 3;
    } else if (style === "park") {
      min = min - 2;
      max = max - 2;
    } else if (style === "freeride") {
      min = min + 2;
      max = max + 2;
    } else if (style === "carving") {
      min = min + 2;
      max = max + 3;
    } else if (style === "powder") {
      min = min + 3;
      max = max + 4;
    }

    return { min: min, max: max };
  }

  function adjustRangeForHeight(range, height, boardCategory) {
    var shift = 0;

    if (boardCategory === "womens") {
      if (height < 150) shift = -1;
      else if (height <= 158) shift = 0;
      else if (height <= 166) shift = 1;
      else if (height <= 174) shift = 2;
      else shift = 3;
    } else {
      if (height < 160) shift = -1;
      else if (height <= 168) shift = 0;
      else if (height <= 176) shift = 1;
      else if (height <= 184) shift = 2;
      else shift = 3;
    }

    return {
      min: range.min + shift,
      max: range.max + shift
    };
  }

  function adjustRangeForLocation(range, location) {
    if (location !== "overseas") {
      return range;
    }

    return {
      min: range.min + 1,
      max: range.max + 2
    };
  }

  function getWidthType(bootMensEquivalent) {
    if (bootMensEquivalent >= 12) return "ultra-wide";
    if (bootMensEquivalent >= 11) return "wide";
    return "standard";
  }

  function getWidthLabel(widthType) {
    if (widthType === "ultra-wide") return "Ultra-wide / Wide";
    if (widthType === "wide") return "Wide";
    return "Standard";
  }

  function getStyleLabel(style) {
    if (style === "beginner") return "Beginner";
    if (style === "ground-tricks") return "Ground Tricks / Jibbing";
    if (style === "park") return "Park / Freestyle";
    if (style === "all-mountain") return "All Mountain";
    if (style === "freeride") return "Freeride";
    if (style === "carving") return "Carving";
    if (style === "powder") return "Powder";
    return "Snowboards";
  }

  function getCategoryLabel(boardCategory) {
    if (boardCategory === "womens") return "Women's";
    if (boardCategory === "unisex") return "Unisex";
    return "Men's";
  }

  function getStyleFilterValue(style) {
    if (style === "beginner") return null;
    if (style === "ground-tricks") return null;
    if (style === "park") return "PARK";
    if (style === "all-mountain") return "ALL MOUNTAIN";
    if (style === "freeride") return "FREERIDE";
    if (style === "carving") return "CARVING";
    if (style === "powder") return "POWDER";
    return null;
  }

  function getBoardFeelFlexValues(boardFeel) {
    if (boardFeel === "easy-forgiving") return ["SOFT", "MID - SOFT"];
    if (boardFeel === "balanced") return ["MID - SOFT", "MID", "MID - STIFF"];
    if (boardFeel === "stable-powerful") return ["MID - STIFF", "STIFF"];
    return [];
  }

  function getStyleDefaultFlexValues(style) {
    if (style === "ground-tricks") return ["SOFT"];
    if (style === "beginner") return ["MID - SOFT"];
    return [];
  }

  function getAppliedFlexValues(boardFeel, style) {
    var boardFeelValues = getBoardFeelFlexValues(boardFeel);
    if (boardFeelValues.length) return boardFeelValues;
    return getStyleDefaultFlexValues(style);
  }

  function getLocationLabel(location) {
    if (location === "australia") return "Australia";
    if (location === "overseas") return "Overseas";
    if (location === "both") return "Australia and Overseas";
    return "";
  }

  function getBoardFeelLabel(boardFeel) {
    if (boardFeel === "easy-forgiving") return "Easy and Forgiving";
    if (boardFeel === "balanced") return "Balanced";
    if (boardFeel === "stable-powerful") return "Stable and Powerful";
    return "";
  }

  function getStandardSizeBucket(range) {
    var midpoint = (range.min + range.max) / 2;

    if (midpoint <= 142) return "136-142";
    if (midpoint <= 148) return "143-148";
    if (midpoint <= 152) return "149-152";
    if (midpoint <= 156) return "153-156";
    if (midpoint <= 161) return "157-161";
    return "162-plus";
  }

  function getWideSizeBucket(range) {
    var midpoint = (range.min + range.max) / 2;

    if (midpoint <= 156.9) return "156w";
    if (midpoint <= 158.4) return "158w";
    if (midpoint <= 159.7) return "159w";
    return "161w";
  }

  function buildCollectionUrl(boardCategory, style, standardBucket, wideBucket, widthType, boardFeel) {
    var collectionKey = boardCategory === "unisex" ? "unisex" : boardCategory;
    var config = BALLISTYX_COLLECTIONS[collectionKey];
    var params = new URLSearchParams();

    params.set("sort_by", "created-descending");

    var styleValue = getStyleFilterValue(style);
    if (styleValue) {
      params.set("filter.p.m.custom.snowboard_style", styleValue);
    }

    var flexValues = getAppliedFlexValues(boardFeel, style);
    for (var i = 0; i < flexValues.length; i++) {
      params.append("filter.p.m.custom.flex_rating", flexValues[i]);
    }

    if (
      (boardCategory === "mens" || boardCategory === "unisex") &&
      (widthType === "wide" || widthType === "ultra-wide")
    ) {
      params.set("filter.v.option.size", config.wideSizes[wideBucket]);
    } else {
      params.set("filter.v.option.size", config.sizes[standardBucket]);
    }

    return config.base + "?" + params.toString();
  }

  function buildSummary(boardCategory, style, range, widthType, wideBucket, bootInput, bootType, bootMensEquivalent, location, boardFeel) {
    var styleText = getStyleLabel(style).toLowerCase();
    var categoryText = getCategoryLabel(boardCategory);
    var locationText = getLocationLabel(location);
    var boardFeelText = getBoardFeelLabel(boardFeel);
    var copy = "Based on your details, a " + categoryText + " " + styleText + " snowboard in the " + range.min + "–" + range.max + " cm range is a strong starting point.";

    if (locationText) {
      copy += " Your setup has been assessed for riding " + locationText + ".";
    }

    if (boardFeelText) {
      copy += " Your board feel preference has been set to " + boardFeelText.toLowerCase() + ".";
    }

    if (bootType === "womens") {
      copy += " Your US Women's boot size of " + bootInput + " has been assessed as approximately US Men's " + bootMensEquivalent.toFixed(1).replace(".0", "") + " for width guidance.";
    } else {
      copy += " Your width recommendation is based on a US Men's boot size of " + bootInput + ".";
    }

    if (style === "beginner") {
      copy += " For beginner riders, it usually makes sense to focus on easier-going boards with a more forgiving flex.";
    }

    if (style === "ground-tricks") {
      copy += " For ground tricks and jibbing, it usually makes sense to stay shorter and softer for easier presses, butters and low-speed manoeuvrability.";
    }

    if (location === "overseas") {
      copy += " For overseas trips, we usually recommend leaning toward the longer end of your range.";
    }

    if (widthType === "standard") {
      copy += " A standard width board should suit you in most models.";
    } else if (widthType === "wide") {
      copy += " With your boot size, you should focus on W sizes where possible.";
    } else if (widthType === "ultra-wide") {
      copy += " With your boot size, you should prioritise the widest options available.";
    }

    if ((boardCategory === "mens" || boardCategory === "unisex") && widthType !== "standard") {
      copy += " You will be routed toward the closest matching wide option, currently " + wideBucket.toUpperCase() + ".";
    }

    return copy;
  }

  function buildGuidanceText(style, location, boardFeel) {
    var baseText = "";

    if (style === "ground-tricks") {
      baseText = "For ground tricks and jibbing, it usually makes sense to stay shorter and softer for easier presses, butters and low-speed manoeuvrability.";
    } else if (style === "park") {
      baseText = "Want a more playful feel? Look toward the shorter end of your range. Want more stability on landings? Look toward the longer end.";
    } else if (style === "powder" || style === "freeride" || style === "carving") {
      baseText = "Want quicker turns? Look toward the shorter end of your range. Want more stability and float? Look toward the longer end.";
    } else if (style === "beginner") {
      baseText = "Want an easier, more forgiving board? Look toward the shorter end of your range. Want a little more support as you progress? Look toward the longer end.";
    } else {
      baseText = "Want a more playful feel? Look toward the shorter end of your range. Want more stability and float? Look toward the longer end.";
    }

    if (boardFeel === "easy-forgiving") {
      baseText += " You are also leaning toward softer, more forgiving flex patterns.";
    } else if (boardFeel === "stable-powerful") {
      baseText += " You are also leaning toward stronger, more powerful flex patterns.";
    }

    if (location === "overseas") {
      baseText += " Because you're riding overseas, it usually makes sense to lean a little longer.";
    }

    return baseText;
  }

  function getEligibleSizes(standardBucket, wideBucket, boardCategory, widthType) {
    if (
      (boardCategory === "mens" || boardCategory === "unisex") &&
      (widthType === "wide" || widthType === "ultra-wide")
    ) {
      return [wideBucket.toLowerCase()];
    }

    var map = {
      "136-142": ["136", "137", "138", "139", "140", "141", "142"],
      "143-148": ["143", "144", "145", "146", "147", "148"],
      "149-152": ["149", "150", "151", "152"],
      "153-156": ["153", "154", "155", "156"],
      "157-161": ["157", "158", "159", "160", "161"],
      "162-plus": ["162", "163", "164", "165", "166", "167", "168", "169", "170"]
    };

    return map[standardBucket] || [];
  }

  function toMoney(cents) {
    if (typeof cents !== "number") return "";
    return "$" + (cents / 100).toFixed(2) + " AUD";
  }

  function parseTags(tags) {
    if (!tags) return [];
    if (Array.isArray(tags)) return tags.map(function (t) { return String(t).toUpperCase(); });
    return String(tags).split(",").map(function (t) { return String(t).trim().toUpperCase(); });
  }

  function hasTag(tags, tagName) {
    var parsed = parseTags(tags);
    return parsed.indexOf(String(tagName).toUpperCase()) !== -1;
  }

  function hasPreorderTag(tags) {
    return hasTag(tags, "PREORDER");
  }

  function hasUnisexTag(tags) {
    return hasTag(tags, "UNISEX");
  }

  function getProductHandleFromUrl(url) {
    var match = String(url || "").match(/\/products\/([^?#/]+)/i);
    return match ? match[1] : null;
  }

  function getVariantSizeValue(variant) {
    if (!variant) return "";

    var candidates = [variant.option1, variant.public_title, variant.title];

    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i]) return String(candidates[i]).trim();
    }

    return "";
  }

  function isEligibleVariantSize(sizeValue, eligibleSizes) {
    var clean = String(sizeValue || "").trim().toLowerCase().replace(/\s+/g, "");
    if (!clean) return false;

    for (var i = 0; i < eligibleSizes.length; i++) {
      var target = String(eligibleSizes[i]).trim().toLowerCase().replace(/\s+/g, "");
      if (clean === target) return true;
    }

    return false;
  }

  function getVariantWeightDataFromCard(card) {
   if (!card) return null;

   var el = card.querySelector(".ballistyx-variant-weight-data");
   if (!el) return null;

   try {
    return JSON.parse(el.getAttribute("data-variants") || "{}");
   } catch (e) {
    console.error("Ballistyx weight JSON error:", e);
    return null;
   }
  }

  function getVariantWeightRange(variant, variantWeightData) {
   if (!variant || !variantWeightData) return null;

   var data = variantWeightData[String(variant.id)];
   if (!data) return null;

   var min = Number(data.min);
   var max = Number(data.max);
 
   if (isNaN(min) || isNaN(max)) return null;

   return { min: min, max: max };
  }

  function getWeightFitScore(riderWeight, weightRange) {
    if (!weightRange) return 0;

    if (riderWeight >= weightRange.min && riderWeight <= weightRange.max) return 3;
    if (riderWeight >= weightRange.min - 5 && riderWeight <= weightRange.max + 5) return 2;
    if (riderWeight >= weightRange.min - 10 && riderWeight <= weightRange.max + 10) return 1;

    return 0;
  }

  function getWeightFitLabel(riderWeight, weightRange) {
    if (!weightRange) return "";

    if (riderWeight >= weightRange.min && riderWeight <= weightRange.max) {
      return "Weight range match";
    }

    if (riderWeight >= weightRange.min - 5 && riderWeight <= weightRange.max + 5) {
      return "Close weight match";
    }

    return "";
  }

  function pickEligibleVariant(productJson, eligibleSizes, riderWeight, variantWeightData) {
    if (!productJson || !productJson.variants || !productJson.variants.length) return null;

    var preorder = hasPreorderTag(productJson.tags);
    var bestInStock = null;
    var bestPreorder = null;
    var bestInStockScore = -1;
    var bestPreorderScore = -1;

    for (var i = 0; i < productJson.variants.length; i++) {
      var variant = productJson.variants[i];
      var sizeValue = getVariantSizeValue(variant);

      if (!isEligibleVariantSize(sizeValue, eligibleSizes)) continue;

      var weightRange = getVariantWeightRange(variant, variantWeightData);
      var weightScore = getWeightFitScore(riderWeight, weightRange);

      if (variant.available && weightScore > bestInStockScore) {
        bestInStock = variant;
        bestInStockScore = weightScore;
      }

      if (preorder && weightScore > bestPreorderScore) {
        bestPreorder = variant;
        bestPreorderScore = weightScore;
      }
    }

    return {
      inStock: bestInStock,
      preorder: bestPreorder,
      inStockWeightFitScore: bestInStockScore < 0 ? 0 : bestInStockScore,
      preorderWeightFitScore: bestPreorderScore < 0 ? 0 : bestPreorderScore
    };
  }

  async function fetchProductJson(productUrl) {
    var handle = getProductHandleFromUrl(productUrl);
    if (!handle) return null;

    var jsonUrl = "/products/" + handle + ".js";
    var response = await fetch(jsonUrl, { credentials: "same-origin" });

    if (!response.ok) {
      throw new Error("Failed to load product JSON: " + jsonUrl);
    }

    return await response.json();
  }

  function getBadgeHtml(isSale, isPreorder) {
    var html = "";

    if (isSale) {
      html += '<span class="ballistyx-product-badge sale">Sale</span>';
    }

    if (isPreorder) {
      html += '<span class="ballistyx-product-badge preorder">Preorder</span>';
    }

    return html;
  }

  function getMatchLabel(product) {
    if (product.weightFitLabel) {
      return product.weightFitLabel + " in " + product.matchedSize;
    }

    if (product.isPreorder) {
      return "Preorder in " + product.matchedSize;
    }

    return "Available in " + product.matchedSize;
  }

  function renderProductCard(product) {
    var compareHtml = product.comparePrice
      ? '<p class="ballistyx-product-card-compare">' + escapeHtml(product.comparePrice) + "</p>"
      : '<p class="ballistyx-product-card-compare"></p>';

    var badgesHtml = getBadgeHtml(product.isSale, product.isPreorder);
    var secondaryImageHtml = product.hoverImage
      ? '<img class="ballistyx-product-card-hover-image" src="' + escapeHtml(product.hoverImage) + '" alt="' + escapeHtml(product.title) + '">'
      : "";

    return (
      '<div class="ballistyx-product-card">' +
        '<a href="' + product.url + '" target="_blank" rel="noopener noreferrer">' +
          '<div class="ballistyx-product-card-image">' +
            (badgesHtml ? '<div class="ballistyx-product-badges">' + badgesHtml + "</div>" : "") +
            '<img class="ballistyx-product-card-main-image" src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '">' +
            secondaryImageHtml +
          "</div>" +
        "</a>" +
        '<div class="ballistyx-product-card-content">' +
          '<p class="ballistyx-product-card-title">' + escapeHtml(product.title) + "</p>" +
          '<p class="ballistyx-product-card-match">' + escapeHtml(getMatchLabel(product)) + "</p>" +
          compareHtml +
          '<p class="ballistyx-product-card-price">' + escapeHtml(product.price || "View product") + "</p>" +
          '<a class="ballistyx-product-card-button" href="' + product.url + '" target="_blank" rel="noopener noreferrer">' +
            (product.isPreorder ? "Preorder now" : "Choose options") +
          "</a>" +
        "</div>" +
      "</div>"
    );
  }

  function createFallbackCard(productUrl) {
    return (
      '<div class="ballistyx-product-card">' +
        '<div class="ballistyx-product-card-content">' +
          '<p class="ballistyx-product-card-title">View matching snowboards</p>' +
          '<p class="ballistyx-product-card-match"></p>' +
          '<p class="ballistyx-product-card-compare"></p>' +
          '<p class="ballistyx-product-card-price">Open filtered results</p>' +
          '<a class="ballistyx-product-card-button" href="' + productUrl + '" target="_blank" rel="noopener noreferrer">Shop boards</a>' +
        "</div>" +
      "</div>"
    );
  }

  function getBeginnerScore(tags) {
    if (hasTag(tags, "BEGINNER")) return 3;
    if (hasTag(tags, "INTERMEDIATE")) return 1;
    return 0;
  }

  function getUnisexScore(tags) {
    return hasUnisexTag(tags) ? 3 : 0;
  }

  function getFlexRatingValue(tags) {
    if (hasTag(tags, "MID - SOFT")) return "MID - SOFT";
    if (hasTag(tags, "MID - STIFF")) return "MID - STIFF";
    if (hasTag(tags, "SOFT")) return "SOFT";
    if (hasTag(tags, "MID")) return "MID";
    if (hasTag(tags, "STIFF")) return "STIFF";
    return "";
  }

  function getBoardFeelRankScore(boardFeel, flexRating) {
    if (!boardFeel || !flexRating) return 0;

    if (boardFeel === "easy-forgiving") {
      if (flexRating === "SOFT") return 4;
      if (flexRating === "MID - SOFT") return 3;
      if (flexRating === "MID") return 1;
      return 0;
    }

    if (boardFeel === "balanced") {
      if (flexRating === "MID") return 4;
      if (flexRating === "MID - SOFT") return 3;
      if (flexRating === "MID - STIFF") return 3;
      if (flexRating === "SOFT" || flexRating === "STIFF") return 1;
      return 0;
    }

    if (boardFeel === "stable-powerful") {
      if (flexRating === "STIFF") return 4;
      if (flexRating === "MID - STIFF") return 3;
      if (flexRating === "MID") return 1;
      return 0;
    }

    return 0;
  }

  function sortForBeginner(products) {
    return products.sort(function (a, b) {
      if (b.weightFitScore !== a.weightFitScore) return b.weightFitScore - a.weightFitScore;
      if (b.beginnerScore !== a.beginnerScore) return b.beginnerScore - a.beginnerScore;
      if (b.boardFeelScore !== a.boardFeelScore) return b.boardFeelScore - a.boardFeelScore;
      if (a.isActuallyInStock !== b.isActuallyInStock) return a.isActuallyInStock ? -1 : 1;
      if (a.isPreorder !== b.isPreorder) return a.isPreorder ? 1 : -1;
      if (a.isSale !== b.isSale) return a.isSale ? -1 : 1;
      return 0;
    });
  }

  function sortForUnisex(products) {
    return products.sort(function (a, b) {
      if (b.weightFitScore !== a.weightFitScore) return b.weightFitScore - a.weightFitScore;
      if (b.unisexScore !== a.unisexScore) return b.unisexScore - a.unisexScore;
      if (b.boardFeelScore !== a.boardFeelScore) return b.boardFeelScore - a.boardFeelScore;
      if (a.isActuallyInStock !== b.isActuallyInStock) return a.isActuallyInStock ? -1 : 1;
      if (a.isPreorder !== b.isPreorder) return a.isPreorder ? 1 : -1;
      if (a.isSale !== b.isSale) return a.isSale ? -1 : 1;
      return 0;
    });
  }

  function sortDefault(products) {
    return products.sort(function (a, b) {
      if (b.weightFitScore !== a.weightFitScore) return b.weightFitScore - a.weightFitScore;
      if (b.boardFeelScore !== a.boardFeelScore) return b.boardFeelScore - a.boardFeelScore;
      if (a.isActuallyInStock !== b.isActuallyInStock) return a.isActuallyInStock ? -1 : 1;
      if (a.isPreorder !== b.isPreorder) return a.isPreorder ? 1 : -1;
      if (a.isSale !== b.isSale) return a.isSale ? -1 : 1;
      return 0;
    });
  }

  function getHeroImage(productJson) {
    if (!productJson) return "";

    if (typeof productJson.featured_image === "string" && productJson.featured_image) {
      return productJson.featured_image;
    }

    if (productJson.featured_image && productJson.featured_image.src) {
      return productJson.featured_image.src;
    }

    if (productJson.images && productJson.images.length > 0) {
      return productJson.images[0];
    }

    return "";
  }

  function getHoverImage(productJson, heroImage) {
    if (!productJson || !productJson.images || productJson.images.length < 2) return "";

    for (var i = 0; i < productJson.images.length; i++) {
      var img = productJson.images[i];
      if (img && img !== heroImage) {
        return img;
      }
    }

    return "";
  }

  function contactCTA() {
    return '<a href="/pages/contact" target="_blank">Get in touch</a> or visit us in store to dial in your setup.';
  }

  function getAlerts(height, weight, category, style, boardFeel, location, bootMens) {
    var alerts = [];

    if (style === "beginner" && boardFeel === "stable-powerful") {
      alerts.push({
        type: "contact",
        text:
          "A stable and powerful feel usually points toward a stiffer, more demanding board, which can make progression harder for beginner riders.<br><br>" +
          contactCTA()
      });
    }

    if (location === "both" && style !== "park" && style !== "freeride") {
      alerts.push({
        type: "contact",
        text:
          "A board for both Australian riding and overseas trips depends heavily on shape, flex and where you want it to feel strongest.<br><br>" +
          contactCTA()
      });
    }

    var isTallLight =
      (category !== "womens" && height >= 185 && weight < 72) ||
      (category === "womens" && height >= 172 && weight < 58);

    var isShortHeavy =
      (category !== "womens" && height < 165 && weight > 85) ||
      (category === "womens" && height < 155 && weight > 72);

    if (isTallLight || isShortHeavy) {
      alerts.push({
        type: "contact",
        text:
          "Your height and weight sit at opposite ends of the sizing guide. In this case, board shape and flex matter more than usual.<br><br>" +
          contactCTA()
      });
    }

    if (style === "ground-tricks" && boardFeel === "stable-powerful") {
      alerts.push({
        type: "advisory",
        text:
          "Ground tricks boards are usually softer and easier to press, while a stable and powerful feel usually points toward a stiffer board. This can work, but it is a more specialised setup."
      });
    }

    if (style === "powder" && boardFeel === "easy-forgiving") {
      alerts.push({
        type: "advisory",
        text:
          "Powder boards often benefit from more support and directional drive than an easy and forgiving feel usually suggests."
      });
    }

    if (bootMens >= 11 && height < 170) {
      alerts.push({
        type: "advisory",
        text:
          "Your boot size makes width a bigger factor in this size range. Pay close attention to waist width and wide models rather than length alone."
      });
    }

    var contactAlerts = [];
    var advisoryAlerts = [];

    for (var i = 0; i < alerts.length; i++) {
      if (alerts[i].type === "contact") {
        contactAlerts.push(alerts[i]);
      } else {
        advisoryAlerts.push(alerts[i]);
      }
    }

    return contactAlerts.concat(advisoryAlerts).slice(0, 2);
  }

  function renderAlerts(alerts) {
    var container = $("ballistyx-alerts");
    if (!container) return;

    if (!alerts.length) {
      container.style.display = "none";
      container.innerHTML = "";
      return;
    }

    var html = '<div class="ballistyx-alert-box">';
    html += "<strong>Worth a closer look</strong>";

    for (var i = 0; i < alerts.length; i++) {
      html += "<p>" + alerts[i].text + "</p>";
    }

    html += "</div>";

    container.innerHTML = html;
    container.style.display = "block";
  }

  async function renderMatchingProducts(collectionUrl, standardBucket, wideBucket, boardCategory, widthType, style, boardFeel, riderWeight) {
   var grid = $("ballistyx-product-grid");
   var wrap = $("ballistyx-product-recommendations");

   if (!grid || !wrap) return;

   grid.innerHTML = "<p>Loading matching boards...</p>";
   wrap.style.display = "block";

   try {
    var collectionResponse = await fetch(normaliseUrl(collectionUrl), {
      credentials: "same-origin"
    });

    if (!collectionResponse.ok) {
      throw new Error("Failed to load filtered collection page");
    }

    var collectionHtml = await collectionResponse.text();
    var doc = new DOMParser().parseFromString(collectionHtml, "text/html");
    var cards = doc.querySelectorAll(".grid__item");

    var candidateUrls = [];
    var candidateWeightData = {};
    var seen = {};

    for (var i = 0; i < cards.length; i++) {
      var link = cards[i].querySelector("a[href*='/products/']");
      if (!link) continue;

      var href = link.getAttribute("href") || "";
      if (!href) continue;
      if (href.toLowerCase().indexOf("gift-card") !== -1) continue;

      var fullHref = normaliseUrl(href);
      if (seen[fullHref]) continue;

      seen[fullHref] = true;
      candidateUrls.push(fullHref);

      var handle = getProductHandleFromUrl(fullHref);
      if (handle) {
        candidateWeightData[handle] = getVariantWeightDataFromCard(cards[i]);
      }
    }

    var eligibleSizes = getEligibleSizes(standardBucket, wideBucket, boardCategory, widthType);
    var inStockMatches = [];
    var preorderMatches = [];

    for (var j = 0; j < candidateUrls.length; j++) {
      if (inStockMatches.length >= 8 && boardCategory !== "unisex") break;

      try {
        var productJson = await fetchProductJson(candidateUrls[j]);
        if (!productJson) continue;

        var handleForProduct = getProductHandleFromUrl(candidateUrls[j]);
        var variantWeightData = handleForProduct ? candidateWeightData[handleForProduct] : null;

        var preorder = hasPreorderTag(productJson.tags);
        var matching = pickEligibleVariant(productJson, eligibleSizes, riderWeight, variantWeightData);

        if (!matching.inStock && !matching.preorder) continue;

        var chosenVariant = matching.inStock || matching.preorder;
        var weightFitScore = matching.inStock ? matching.inStockWeightFitScore : matching.preorderWeightFitScore;
        var weightRange = getVariantWeightRange(chosenVariant, variantWeightData);
        var weightFitLabel = getWeightFitLabel(riderWeight, weightRange);
        var heroImage = getHeroImage(productJson);
        var hoverImage = getHoverImage(productJson, heroImage);
        var flexRating = getFlexRatingValue(productJson.tags);
        var boardFeelScore = getBoardFeelRankScore(boardFeel, flexRating);

        var price = toMoney(chosenVariant.price);
        var comparePrice = "";
        var isSale = false;

        if (
          typeof chosenVariant.compare_at_price === "number" &&
          chosenVariant.compare_at_price > chosenVariant.price
        ) {
          comparePrice = toMoney(chosenVariant.compare_at_price);
          isSale = true;
        }

        var isActuallyInStock = !!matching.inStock;
        var isTaggedPreorder = preorder;

        var productData = {
          url: candidateUrls[j],
          title: productJson.title || "Snowboard",
          image: heroImage,
          hoverImage: hoverImage,
          price: price,
          comparePrice: comparePrice,
          isSale: isSale,
          isPreorder: isTaggedPreorder,
          isActuallyInStock: isActuallyInStock,
          matchedSize: getVariantSizeValue(chosenVariant),
          beginnerScore: getBeginnerScore(productJson.tags),
          unisexScore: getUnisexScore(productJson.tags),
          flexRating: flexRating,
          boardFeelScore: boardFeelScore,
          weightFitScore: weightFitScore,
          weightFitLabel: weightFitLabel
        };

        if (matching.inStock) {
          inStockMatches.push(productData);
        } else if (matching.preorder) {
          preorderMatches.push(productData);
        }
      } catch (productError) {
        console.error("Ballistyx product JSON error:", productError);
      }
    }

    if (style === "beginner") {
      inStockMatches = sortForBeginner(inStockMatches);
      preorderMatches = sortForBeginner(preorderMatches);
    } else if (boardCategory === "unisex") {
      inStockMatches = sortForUnisex(inStockMatches);
      preorderMatches = sortForUnisex(preorderMatches);
    } else {
      inStockMatches = sortDefault(inStockMatches);
      preorderMatches = sortDefault(preorderMatches);
    }

    var finalProducts = inStockMatches.concat(preorderMatches).slice(0, 4);
    var noWideResults =
      (widthType === "wide" || widthType === "ultra-wide") &&
      finalProducts.length === 0;

    if (noWideResults) {
      var alertsContainer = $("ballistyx-alerts");

      if (alertsContainer) {
        alertsContainer.innerHTML =
          '<div class="ballistyx-alert-box">' +
            '<strong>Worth a closer look</strong>' +
            '<p>Based on your boot size, you will typically want a wide snowboard. We currently do not have a close match in stock in that width range.</p>' +
            '<p>Some mid-wide models may still work depending on the board shape and your setup, but it is worth getting this dialled in properly.</p>' +
            '<p>' + contactCTA() + '</p>' +
          '</div>';

        alertsContainer.style.display = "block";
      }

      grid.innerHTML = createFallbackCard(collectionUrl);
      return;
    }

    if (!finalProducts.length) {
      grid.innerHTML = createFallbackCard(collectionUrl);
      return;
    }

    var html = "";
    for (var k = 0; k < finalProducts.length; k++) {
      html += renderProductCard(finalProducts[k]);
    }

    grid.innerHTML = html;
   } catch (error) {
    console.error("Ballistyx recommendations error:", error);
    grid.innerHTML = createFallbackCard(collectionUrl);
   }
  }


  function populateDropdown(selectId, start, end, step, suffix) {
    var el = document.getElementById(selectId);
    if (!el) return;

    if (el.options && el.options.length > 1) return;

    for (var i = start; i <= end + 0.0001; i += step) {
      var option = document.createElement("option");
      var value = Number(i.toFixed(1));
      option.value = value;
      option.textContent = suffix ? value + " " + suffix : value;
      el.appendChild(option);
    }
  }

  async function calculate() {
    var height = parseFloat($("ballistyx-height").value);
    var weight = parseFloat($("ballistyx-weight").value);
    var category = $("ballistyx-board-category").value;
    var style = $("ballistyx-style").value;
    var bootInput = parseFloat($("ballistyx-boot").value);
    var bootType = $("ballistyx-boot-type").value;
    var location = $("ballistyx-location") ? $("ballistyx-location").value : "";
    var boardFeel = $("ballistyx-board-feel") ? $("ballistyx-board-feel").value : "";

    if (!height || !weight || !category || !style || !bootInput || !location || !boardFeel) {
      alert("Please enter your height, weight, board category, boot size, riding style, where you are riding, and preferred board feel.");
      return;
    }

    var bootMensEquivalent = bootType === "womens" ? bootInput - 1.5 : bootInput;

    var alerts = getAlerts(height, weight, category, style, boardFeel, location, bootMensEquivalent);
    renderAlerts(alerts);

    var baseRange = getBaseRangeFromWeight(weight, category);
    var styleAdjustedRange = adjustRangeForStyle(baseRange, style);
    var heightAdjustedRange = adjustRangeForHeight(styleAdjustedRange, height, category);
    var range = adjustRangeForLocation(heightAdjustedRange, location);

    var widthType = getWidthType(bootMensEquivalent);
    var widthLabel = getWidthLabel(widthType);
    var styleLabel = getStyleLabel(style);
    var categoryLabel = getCategoryLabel(category);

    var standardBucket = getStandardSizeBucket(range);
    var wideBucket = getWideSizeBucket(range);
    var url = buildCollectionUrl(category, style, standardBucket, wideBucket, widthType, boardFeel);

    $("ballistyx-size-output").textContent = range.min + "–" + range.max + " cm";
    $("ballistyx-width-output").textContent = widthLabel;
    $("ballistyx-style-output").textContent = styleLabel;
    $("ballistyx-category-output").textContent = categoryLabel;
    $("ballistyx-summary-output").textContent = buildSummary(
      category,
      style,
      range,
      widthType,
      wideBucket,
      bootInput,
      bootType,
      bootMensEquivalent,
      location,
      boardFeel
    );

    var guidance = $("ballistyx-guidance-output");
    if (guidance) {
      guidance.textContent = buildGuidanceText(style, location, boardFeel);
    }

    var shopLink = $("ballistyx-shop-link");
    shopLink.href = url;
    shopLink.textContent = "Shop Matching Boards";
    shopLink.style.color = "#fff";

    $("ballistyx-calc-result").style.display = "block";

    await renderMatchingProducts(url, standardBucket, wideBucket, category, widthType, style, boardFeel, weight);
  }

  function init() {
    populateDropdown("ballistyx-height", 140, 200, 1, "cm");
    populateDropdown("ballistyx-weight", 40, 120, 1, "kg");
    populateDropdown("ballistyx-boot", 4, 15, 0.5);

    var btn = $("ballistyx-calc-button");
    if (btn) {
      btn.addEventListener("click", calculate);
    }

    var bootType = $("ballistyx-boot-type");
    if (bootType) {
      bootType.addEventListener("change", updateBootLabel);
    }

    updateBootLabel();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();